import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Store from './store';

const styles = require('./index.less');
/**
 * 弹窗模板, 可以快速套用修改
 * @param {CdkeysModalStore} store
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const TeamXcxModalModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.teamXcxRoot)}>
        <div className={styles.closeBtn} onClick={store.onClickClose} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(TeamXcxModalModal, Store);
